module.exports = __webpack_public_path__ + "assets/img/3001.fc6d89f4.svg";